<template>
  <div class="admin-user">
    <commonTable :config="{nothing}" tableHead="user" ref="commonTable" :params="ruleForm" :apiUrl="{url:'user',methods:'userRolesIndex'}" :selection="false" :tipShow="false" :verifyRemark="$permission(['用户角色管理-更新用户角色','用户角色管理-用户角色详情','用户权限管理-更新用户权限'])">
      <template #table_head>
        <div class="search-params">
          <el-input prefix-icon="icon iconfont iconicon_search1" v-model="ruleForm.keyword" placeholder="搜索用户名称" clearable @keyup.enter.native="getRoleList" @input="getRoleList"></el-input>
        </div>
      </template>
      <template slot="roles" slot-scope="dataset">
        <span>{{getRolesItem(dataset.data.roles)}}</span>
      </template>
      <template slot="verifyRemark" slot-scope="dataset">
        <span @click="edit(dataset.data)" v-permission="'用户角色管理-更新用户角色'">角色</span>
        <span @click="editRole(dataset.data)" v-permission="'用户权限管理-更新用户权限'">权限</span>
      </template>
    </commonTable>
    <userEdit v-if="paramsSet.dialogVisible" v-model="paramsSet.dialogVisible" :paramsSet="paramsSet" @complete="complete" @close="paramsSet.dialogVisible = false" />
    <roleEdit v-model="paramsRole.dialogVisible" v-if="paramsRole.dialogVisible" :paramsSet="paramsRole" @complete="complete" @close="paramsRole.dialogVisible = false" />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import basiCcontainer from '@/layouts/app/components/basiCcontainer';
import userEdit from './userEdit'
import roleEdit from './roleEdit'
export default {
  components: {
    basiCcontainer,
    userEdit,
    roleEdit
  },
  data() {
    return {
      ruleForm: {
        keyword: ''
      },
      paramsSet: {
        dialogVisible: false,
        uid: ''
      },
      paramsRole: {
        dialogVisible: false,
        uid: ''
      },
      nothing: {
        tip: '暂无员工信息'
      },
      timer: null
    }
  },
  created() {
    let { fullPath, path, query, name } = this.$route
  },
  computed: {
  },
  mounted() {
    this.init()
  },
  methods: {
    getRolesItem(data) {
      return data && data.length > 0 ? data.map(res => res.role_name).join('，') : '-'
    },
    init() {
      this.$refs.commonTable.getTableList()
    },
    edit(data) {
      this.paramsSet = {
        dialogVisible: true,
        uid: data.uid
      }
    },
    editRole(data) {
      this.paramsRole = {
        dialogVisible: true,
        uid: data.uid
      }
    },
    getRoleList() {
      this.debounce(this.init, 300)
    },
    complete() {
      this.paramsSet.dialogVisible = false
      this.paramsRole.dialogVisible = false
      this.init()
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
.admin-user {
  // padding: 30px;
  padding: 0 40px;
  height: 100%;

  .ovfl {
    overflow: hidden;
  }
  .block {
    margin-top: 30px;
  }
  .el-form {
    height: 50px;
    line-height: 50px;
  }
  .el-form-item {
    margin: 0;
    display: inline-block;
  }
  .search-params {
    display: flex;
    justify-content: flex-start;
    padding: 24px 0;
    .el-input {
      width: 360px;
    }
  }
  ::v-deep {
    .el-input-group__prepend .el-select .el-input {
      width: 130px;
    }
    .ovfl {
      .el-form-item {
        margin-bottom: 9px;
      }
    }
  }
}
</style>
